import { motion } from 'framer-motion';

interface Detail {
  label: string;
  title: string;
  body: string;
  image: string;
  reverse: boolean;
}

interface ServiceDetailsProps {
  details: Detail[];
}

const itemVariants = {
  hidden: { opacity: 0, y: 32 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.55, ease: [0.25, 0.46, 0.45, 0.94] } },
};

export default function ServiceDetails({ details }: ServiceDetailsProps) {
  return (
    <section className="py-24 lg:py-32 bg-[#0f1419]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-8 flex flex-col gap-24">
        {details.map((d, i) => (
          <motion.div
            key={i}
            variants={itemVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            className={`flex flex-col ${d.reverse ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-center gap-14`}
          >
            {/* Image */}
            <div className="w-full lg:w-1/2 shrink-0">
              <div className="relative rounded-[20px] overflow-hidden w-full h-[320px] lg:h-[380px]">
                <img
                  src={d.image}
                  alt={d.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0f1419]/60 to-transparent"></div>
                {/* Cyan border glow */}
                <div className="absolute inset-0 rounded-[20px] border border-[rgba(0,212,255,0.18)] pointer-events-none"></div>
              </div>
            </div>

            {/* Text */}
            <div className="w-full lg:w-1/2 flex flex-col gap-5">
              <div className="inline-block px-4 py-1.5 rounded-full bg-[rgba(0,212,255,0.12)] border border-[rgba(0,212,255,0.25)] w-fit">
                <span className="text-[#00d4ff] text-xs font-semibold uppercase tracking-[2px] whitespace-nowrap">
                  {d.label}
                </span>
              </div>
              <h2 className="text-white font-bold text-3xl md:text-4xl leading-tight">{d.title}</h2>
              <p className="text-[rgba(255,255,255,0.65)] text-base leading-relaxed">{d.body}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
